import {Role} from '../model/role';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiRouteConfig} from '../../../config/api.route.config';
import {AppConfig} from '../../../config/app.config';
import {PermissionGroup} from '../../roles/model/permission-group';
import {Permission} from '../../roles/model/permission';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { camelCase } from 'lodash-es';

@Injectable()
export class RolesService {

  constructor(private http: HttpClient, private config: ApiRouteConfig, private appConfig: AppConfig) {
  }

  getPermissions(): Observable<PermissionGroup[]> {
    return this.http.get<PermissionGroup[]>(this.config.PERMISSIONS).pipe(map(groups => {
      const result: PermissionGroup[] = [];
      for (const key of Object.keys(groups)) {
        if (groups.hasOwnProperty(key)) {
          result.push({name: key, permissions: groups[key].map(p => {
            return {id: p, name: camelCase(p)} as Permission;
          })} as PermissionGroup);
        }
      }
      return result;
    }));
  }

  getRoles(short: string = 'false'): Observable<Role[]> {
    return this.http.get<Role[]>(this.config.ROLE, {params: {'shortRep': short}}).pipe(map(roles => roles.slice(0, this.appConfig.MAX_ROLES)));
  }

  changePermissionForRole(roleId: number, permissionId: string, isActive: boolean) {
    if (isActive) {
      return this.http.post(this.config.getRouteWithInjectedParams(
        this.config.ROLE_PERMISSION, [roleId.toString()]), {'permission': permissionId}
        );
    } else {
      return this.http.delete(this.config.getRouteWithInjectedParams(
        this.config.ROLE_PERMISSION_DELETE, [roleId.toString(), permissionId])
      );
    }
  }

  deleteRole(roleId: number) {
    return this.http.delete(this.config.getRouteWithInjectedParams(this.config.ROLE_DELETE, [roleId.toString()]));
  }

  addRole(name: string): Observable<Role> {
    return this.http.put<Role>(this.config.ROLE, {name: name, removable: true, permissions: []} as Role);
  }

  editRole(role: Role) {
    return this.http.post(this.config.ROLE, role);
  }
}
